import { render } from "./BranchTransactions.vue?vue&type=template&id=068024ee&scoped=true"
import script from "./BranchTransactions.vue?vue&type=script&lang=js"
export * from "./BranchTransactions.vue?vue&type=script&lang=js"

import "./BranchTransactions.vue?vue&type=style&index=0&id=068024ee&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068024ee"]])

export default __exports__